import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../redux/axiosBaseQuery";
import { baseApi } from "../../redux/baseAPI";
import axios from "axios";

export const evaluationApi = baseApi.injectEndpoints({
  tagTypes: ["evaluation"],
  endpoints: (builder) => ({
    fetchEvaluation: builder.query({
      query: (pid) => {
        return {
          url: `/brip/evaluation_listing.json?pid=${pid}`,
          method: "GET",
        };
      },
      transformResponse: (response, loading, arg) => response.response.data,
      providesTags: ["evaluation"],
      // preferCacheValue: false,
    }),
    deleteEvaluation: builder.mutation({
      query: (body) => ({
        url: `/brip/delete_evaluation.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["evaluation"],
      transformResponse: (response, meta, arg) => response.response,
    }),

    addEvaluation: builder.mutation({
      query: (payload) => {
        return {
          url: `/brip/add_evaluation.json`,
          method: "post",
          data: payload,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: [{ type: "evaluation" }],
    }),
  }),
});

export const {
  useFetchEvaluationQuery,
  useDeleteEvaluationMutation,
  useAddEvaluationMutation,
} = evaluationApi;
